module.exports = __webpack_public_path__ + "static/screen05-4a34e53c24e92fe7e7f4b34ad0452154.jpg";